import z from 'zod'

import { fetchStrapi, type FetchStrapiParams } from '@/src/domains/strapi/utils/fetchStrapi'

const localizationItemSchema = z.object({
  slug: z.string(),
  locale: z.string(),
})

const localizationsDataSchema = z.array(
  localizationItemSchema.extend({
    localizations: z.array(localizationItemSchema),
  }),
)

export async function fetchStrapiLocalizedSlugs({
  slug,
  contentType,
  cache,
}: {
  slug: string
  contentType: FetchStrapiParams['contentType']
  cache?: FetchStrapiParams['cache']
}) {
  const data = await fetchStrapi({
    contentType,
    query: {
      fields: ['slug', 'locale'],
      populate: { localizations: { fields: ['slug', 'locale'] } },
      filters: {
        slug: {
          $eq: slug,
        },
      },
    },
    schema: localizationsDataSchema,
    cache,
  })

  const item = data.at(0)

  return item === undefined ? [] : [{ slug: item.slug, locale: item.locale }, ...item.localizations]
}
